<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapGetters({
      authCheck: 'checkAuth',
    }),
  },
  watch: {
    authCheck(n) {
      if (n) {
        this.$router.push({ name: 'Home' });
      } else if (!n && this.$route.name !== 'login') {
        this.$router.push('/');
      }
    },
  },
  mounted() {
    this.$router.onReady(() => {
      this.fetchComposite();
      this.checkAuthStatus();
    });
  },
  methods: {
    ...mapActions(['fetchComposite']),
    async checkAuthStatus() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_AUTH_URL}/auth/session`,
          { credentials: 'include' }
        );
        if (!response.ok) {
          this.$store.commit('SET_UNAUTHENTICATED');
          return;
        }
        const data = await response.json();
        if (data && data.user && data.user.accessToken) {
          this.$store.commit('SET_AUTH', { accessToken: data.user.accessToken });
        } else {
          this.$store.commit('SET_UNAUTHENTICATED');
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Auth check failed:', err);
        this.$store.commit('SET_UNAUTHENTICATED');
      }
    },
  },
};
</script>
<style lang="scss">
@import './assets/css/main.css';

.ol-geocoder {
  left: calc(2vw + 2em) !important;

  .gcd-txt-control {
    height: 48px !important;
    border-radius: 4px;
    webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }

  .gcd-txt-glass {
    top: 12px !important;
  }
}

.ol-geocoder ul.gcd-txt-result {
  z-index: 99;
}

.ol-geocoder .gcd-txt-control {}

#gcd-input-query {
  padding: 0 30px 0 40px !important;
}

*[role='radiogroup'] {
  justify-content: center;
}

.v-messages {
  padding-top: 12px;
}
</style>
